<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <path
      fill="currentColor"
      d="M7.854 1.146a.5.5 0 1 0-.708.708L8.293 3H6a3 3 0 0 0-3 3v2.293L1.854 7.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 1 0-.707-.707L4 8.292V6a2 2 0 0 1 2-2h2.293L7.146 5.146a.5.5 0 1 0 .708.708l2-2a.5.5 0 0 0 0-.708zM7 12V7h5V4h-1.085a1.5 1.5 0 0 0 0-1H14.5A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5v-3.585c.323.114.677.114 1 0V12zm-3 2.5a1.5 1.5 0 0 0 1.356 1.493L5.5 16H7v-3H4zm8-1.5H8v3h4zm2.5 3a1.5 1.5 0 0 0 1.493-1.355L16 14.5V13h-3v3zM12 8H8v4h4zm1 0v4h3V8zm0-4v3h3V5.5a1.5 1.5 0 0 0-1.355-1.493L14.5 4z"
    />
  </svg>
</template>
